import {
  addDays, endOfMonth, getDate, set, startOfMonth,
} from 'date-fns';
import { EnergyTrendsData } from '../types';

export const generateDisabledData = (): EnergyTrendsData => {
  const startDate = startOfMonth(new Date());
  const finalDate = set(endOfMonth(new Date()), {
    hours: 0,
    milliseconds: 0,
    minutes: 0,
    seconds: 0,
  });
  let aux = startDate;

  const trendsData: EnergyTrendsData['trendsData'] = [];
  let consumption = 0;
  let consumptionTarget = 0;

  while (aux <= finalDate) {
    trendsData.push({
      time: aux.toISOString().substring(0, 19),
      consumption,
      consumptionTarget,
      consumptionForecast: 0,
      consumptionOverTarget: 0,
      consumptionPercentage: 0,
    });
    aux = addDays(aux, 1);
    consumption += 50;
    consumptionTarget += 50;
  }

  const days = getDate(finalDate);

  return {
    totalConsumption: 0,
    monthlyForecast: 0,
    monthlyForecastPercentage: 0,
    totalConsumptionPercentage: 0,
    monthlyTarget: 100 * days,
    trendsData,
  };
};
